import { PortfolioPanel } from '@/modules/projects'

export function ProjectPortfolioPage() {
  return <PortfolioPanel />
}
